import { useAdminLocale } from '../../lib/admin-locale.js';
import { cx } from './utils.js';

const STATUS_LABEL: Record<string, readonly [string, string]> = {
  ACTIVE: ['Ενεργό', 'Active'],
  CONNECTED: ['Συνδεδεμένο', 'Connected'],
  SUCCEEDED: ['Ολοκληρώθηκε', 'Succeeded'],
  READY: ['Έτοιμο', 'Ready'],
  ANSWERED: ['Απαντήθηκε', 'Answered'],
  HELPFUL: ['Χρήσιμη', 'Helpful'],
  FAILED: ['Απέτυχε', 'Failed'],
  REVOKED: ['Ανακλήθηκε', 'Revoked'],
  DELETED: ['Διαγράφηκε', 'Deleted'],
  EXPIRED: ['Έληξε', 'Expired'],
  REFUSED: ['Απορρίφθηκε', 'Refused'],
  DISABLED: ['Ανενεργό', 'Disabled'],
  UNLINKED: ['Χωρίς αποστολή', 'Unlinked'],
  SUSPENDED: ['Σε αναστολή', 'Suspended'],
  NOT_HELPFUL: ['Μη χρήσιμη', 'Not helpful'],
  PENDING: ['Εκκρεμεί', 'Pending'],
  DRAFT: ['Πρόχειρο', 'Draft'],
  IN_PROGRESS: ['Σε εξέλιξη', 'In progress'],
  PARTIAL: ['Μερική πληρωμή', 'Partially paid'],
  OPEN: ['Απλήρωτο', 'Unpaid'],
  PAID: ['Πληρωμένο', 'Paid'],
  VOID: ['Ακυρωμένο', 'Void'],
  OVERDUE: ['Εκπρόθεσμο', 'Overdue'],
  NEW: ['Νέο', 'New'],
  INVITED: ['Εκκρεμεί πρόσκληση', 'Invitation pending'],
  WITHIN: ['Εντός ορίου', 'Within limit'],
  NEAR: ['Κοντά στο όριο', 'Near limit'],
  AT: ['Στο όριο', 'At limit'],
  SHARED: ['Χωρίς ξεχωριστό όριο', 'No separate limit'],
};

const GOOD = new Set([
  'ACTIVE',
  'CONNECTED',
  'SUCCEEDED',
  'READY',
  'ANSWERED',
  'HELPFUL',
  'PAID',
  'WITHIN',
  'ok',
  'up',
  'ready',
]);
const BAD = new Set([
  'FAILED',
  'REVOKED',
  'DELETED',
  'EXPIRED',
  'REFUSED',
  'DISABLED',
  'SUSPENDED',
  'VOID',
  'OVERDUE',
  'NOT_HELPFUL',
  'AT',
  'down',
  'degraded',
]);
const WARN = new Set([
  'PENDING',
  'DRAFT',
  'IN_PROGRESS',
  'OPEN',
  'PARTIAL',
  'NEW',
  'INVITED',
  'NEAR',
  'UNLINKED',
]);

export function Badge(props: { value: string | undefined | null; label?: string | undefined }) {
  const { text } = useAdminLocale();
  const value = props.value ?? '';
  const statusLabel = STATUS_LABEL[value];
  const tone = GOOD.has(value)
    ? 'border-emerald-600/25 bg-emerald-50 text-emerald-800 dark:border-emerald-400/25 dark:bg-emerald-950/40 dark:text-emerald-300'
    : BAD.has(value)
      ? 'border-rose-600/25 bg-rose-50 text-rose-800 dark:border-rose-400/25 dark:bg-rose-950/40 dark:text-rose-300'
      : WARN.has(value)
        ? 'border-amber-600/25 bg-amber-50 text-amber-900 dark:border-amber-400/25 dark:bg-amber-950/40 dark:text-amber-200'
        : 'border-slate-300 bg-slate-50 text-slate-700 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-300';
  return (
    <span
      className={cx(
        'admin-mono inline-flex items-center rounded-[4px] border px-1.5 py-0.5 text-[10px] font-medium tracking-[0.06em] uppercase',
        tone,
      )}
    >
      {props.label ?? (statusLabel ? text(statusLabel[0], statusLabel[1]) : value)}
    </span>
  );
}
